module.exports = __webpack_public_path__ + "img/collaborate_5.f09efd3e.jpg";